import {Injectable} from '@angular/core';
import { ActivatedRoute, NavigationEnd, NavigationError, Params, Router } from '@angular/router';
import { StorageService } from './storage.service';
import { UrlParam } from '../enums/group-param.enum';

@Injectable()
export class RouteService {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService
  ) {
  }

  private readonly BASE_URL = '';
  private readonly MERCHANT_INDEX = 1;
  private readonly MERCHANT_ID_INDEX = 2;
  private readonly GROUP_ID_INDEX = 2;
  private readonly TAB_ID_INDEX = 2;
  private readonly GROUP_TAB_ID_INDEX = 3;
  private readonly LOCATION_INDEX = 3;
  private readonly LOCATION_ID_INDEX = 4;
  private readonly SPLITTED_URL_THRESHHOLD = 3;
  private readonly LOCATION_URL_MIN_LENGTH = 5;
  private readonly SPLITTED_URL_THRESHHOLD_GROUP = 4;
  private readonly GROUP_INDEX = 2;
  static splitParam(url: string): string {
    if (url.split('?')[0]) {
      return url.split('?')[0];
    }
    return url;
  }

  public getFindMerchantPage(): string {
    return `${this.BASE_URL}/find-merchant`;
  }

  public getKyooTechPage(): string {
    return this.BASE_URL;
  }

  public getBaseUrl(): string {
    const splittedUrl = this.router.url.split('/');
    let baseUrl = this.BASE_URL;
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD) {
      baseUrl = `${splittedUrl[this.MERCHANT_INDEX]}/${splittedUrl[this.MERCHANT_ID_INDEX]}`;
    }
    return RouteService.splitParam(baseUrl);
  }

  public getGroupBaseUrl(): string {
    const splittedUrl = this.router.url.split('/');
    let baseUrl = this.BASE_URL;
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD_GROUP) {
      baseUrl = `${splittedUrl[this.GROUP_INDEX]}/${splittedUrl[this.GROUP_ID_INDEX + 1]}`;
    }
    return RouteService.splitParam(baseUrl);
  }

  public getLocationUrl(url: string = null): string {
    const splittedUrl = (url || this.router.url).split(/[/?]/);
    let locationUrl = this.BASE_URL;
    if (splittedUrl.length >= this.LOCATION_URL_MIN_LENGTH) {
      locationUrl = `${splittedUrl[this.MERCHANT_INDEX]}/${splittedUrl[this.MERCHANT_ID_INDEX]}` +
        `/${splittedUrl[this.LOCATION_INDEX]}/${splittedUrl[this.LOCATION_ID_INDEX]}`;
    }
    return locationUrl;
  }

  public getGroupUrl(url: string = null): string {
    const splittedUrl = (url || this.router.url).split(/[/?]/);
    let baseUrl = this.BASE_URL;
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD) {
      baseUrl = `${splittedUrl[this.MERCHANT_INDEX]}/${splittedUrl[this.GROUP_ID_INDEX]}`;
    }
    return baseUrl;
  }

  public getMerchantId(): string {
    const splittedUrl = this.router.url.split('/');
    let merchant = '';
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD) {
      merchant = splittedUrl[this.MERCHANT_ID_INDEX];
    }
    return RouteService.splitParam(merchant);
  }

  public getGroupId(): string {
    const splittedUrl = this.router.url.split('/');
    if (splittedUrl[2].includes('?')) {
      splittedUrl[2] = splittedUrl[2].split('?')[0];
    }
    let group = '';
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD) {
      group = splittedUrl[this.GROUP_ID_INDEX];
    }
    return group;
  }

  public getGroupIdLocation(): string {
    const splittedUrl = this.router.url.split('/');
    if (splittedUrl[3].includes('?')) {
      splittedUrl[3] = splittedUrl[3].split('?')[0];
    }
    let group = '';
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD_GROUP) {
      group = splittedUrl[this.GROUP_ID_INDEX + 1];
    }
    return group;
  }

  public getTabId(): string {
    const splittedUrl = this.router.url.split('/');
    let tab = '';
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD) {
      tab = splittedUrl[this.TAB_ID_INDEX];
    }
    return tab;
  }

  public getGroupTabId(): string {
    const splittedUrl = this.router.url.split('/');
    let tab = '';
    if (splittedUrl.length >= this.SPLITTED_URL_THRESHHOLD) {
      tab = splittedUrl[this.GROUP_TAB_ID_INDEX];
    }
    return tab;
  }

  public getCurrentUrl(): string {
    const splittedUrl = this.router.url.split('/').filter(urlPart => {
      if (urlPart) return urlPart;
    });
    return splittedUrl.join('/');
  }

  public getLocationId(): string {
    // FIXME: change this. Change service with inject route and init params in constructor
    if (this.route.snapshot.queryParams.locationId) {
      return this.route.snapshot.queryParams['locationId'];
    } else {
      return null;
    }
  }

  public createLocationUrl(merchantId: string, locationId: string) {
    return `merchants/${merchantId}/locations/${locationId}`;
  }

  public createGroupUrl(groupId: string) {
    return `groups/${groupId}`;
  }

  public checkParams(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (Object.keys(this.route.snapshot.queryParams).length) {
          return;
        }
        this.router.navigate([], { relativeTo: this.route, queryParams: this.getParams()});
      }
    });
  }
  private getParams(): any {
    const params: Params = {};
    Object.values(UrlParam).forEach(key => {
      const value = this.storageService.getSessionStorage(key);
      if (key === UrlParam.cartItems) {
        return;
      }
      if (value) {
        params[key] = value;
      }
    });
    return params;
  }
}
